import { HttpStatusCode } from '@thesavingsgroup/enums/HttpStatusCode';

/**
 * Builds the redirect a route loader returns to send the user to an `/apply` step.
 *
 * The parameters of the originating request are carried onto the redirect so
 * guards reading them afterwards (ex: `RouteChangeGuard`'s analytics) still see them.
 */
export const toApplyRedirect = (step: string, url: string): Response => {
  const redirectUrl = new URL(step, window.location.origin);

  redirectUrl.search = new URL(url).search;

  return Response.redirect(redirectUrl.toString(), HttpStatusCode.FOUND);
};
